<div class="account-setup">
  <div>
    <div class="col-12 mb-40">
      <mat-icon class="success-icon" svgIcon="checkmark-circle"></mat-icon>
    </div>
    <div class="col-12 mb-20">
      <div class="heading">
        <adp-label labelKey="Signup_Success_Heading_Email_Text"></adp-label><br>
        <div style="margin-top:20px;"><span style="font-weight:600;word-break:break-all;">{{primaryEmailAddress}}</span></div>
      </div>
    </div>
  </div>
  <div class="success-container container">
    <div class="row">
      <div class="col-12">
        <p class="text-center success-label">
          <adp-label labelKey="Signup_Create_Account_Success_Email_Text"></adp-label>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-10">
        <button mat-flat-button color="accent" (click)="navigateToLogin()" [gtmClick]="getViewLabel('Signup_Create_Account_Success_Button')">
          <adp-label labelKey="Signup_Create_Account_Contact_LoginButton_Text"></adp-label>
        </button>
      </div>
    </div>
  </div>
</div>
